import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
// Self-hosted fonts FIRST (offline), then the design tokens + global stylesheet, then app CSS.
import './design/typography';
import './design/tokens.css';
import './design/global.css';

const rootEl = document.getElementById('root');
if (rootEl === null) {
  throw new Error('#root element not found');
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
